import axios from "axios"
import {Loading, Message} from "element-ui";
import { saveAs } from 'file-saver'
import qs from 'qs';
import router from '../router/index'

/** 线上：用户端接口根路径 */
export const baseOrigin = 'https://epolicy.industryos.cn';
export const appApiPrefix = '/prod-api/app-api';
/** 本地后端（前端跑在 localhost 时自动使用） */
export const baseURL2 = 'http://localhost:48080/app-api';
/** 勿带末尾 /，与 `/member/auth/login` 等 url 拼接 */
const isLocalFront =
  typeof window !== 'undefined' &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
// export const baseURL = isLocalFront ? baseURL2 : baseOrigin + appApiPrefix;
export const baseURL = baseOrigin + appApiPrefix;

export const imgBaseURL = 'http://223.4.70.200:9020'; // 图片基础路径
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

// export const baseURL = 'http://192.168.0.110:9010';

let downloadLoadingInstance;
const service = axios.create({
  baseURL: baseURL,
  timeout: 600000,
  paramsSerializer: function (params) {
    return qs.stringify(params,{arrayFormat: 'brackets'});
  }
})
let showLoading = null;
/** 并发 401 时共用一个刷新 Promise，避免重复调 refresh-token */
let refreshTokenPromise = null;
/** 避免多个 401 同时 replace 登录页互相取消导航 */
let redirectingToLogin = false;

function redirectToLogin() {
  const p = router?.currentRoute?.path || '';
  if (!p || p.startsWith('/login') || redirectingToLogin) return;
  redirectingToLogin = true;
  router
    .replace({ path: '/login', query: { redirect: p } })
    .catch(() => {})
    .finally(() => {
      // 稍后再允许，避免登录页内接口 401 死循环；离开登录后可再次跳转
      setTimeout(() => {
        redirectingToLogin = false;
      }, 800);
    });
}

service.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }
  if (!config.headers["Content-Type"] && !config.headers["contentType"]) {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
  }
  const token = localStorage.getItem(ACCESS_TOKEN_KEY) || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  // if (!config.skipLoading) {
  //   showLoading = Loading.service({
  //     lock: true,
  //     text: config.loadingText || '加载中...',
  //     spinner: 'el-icon-loading',
  //     background: 'rgba(0, 0, 0, 0.7)',
  //   });
  // }
  // if (config.method === 'get' && config.params) {
  //   const encodedParams = new URLSearchParams(config.params);
  //   config.params = encodedParams;
  // }
  return config
})

service.interceptors.response.use(
  async (response) => {
    // if (showLoading) showLoading.close();
    if (response.config.responseType === 'blob' || response.data instanceof Blob) {
      return response.data;
    }
    const payload = response.data;
    const code = payload && payload.code !== undefined ? payload.code : 200;
    /** Yudao CommonResult 成功 code 为 0；兼容旧接口 200 */
    const ok = code === 0 || code === 200;
    if (code === 401) {
      const cfg = response.config;
      const skipAuthRedirect = !!(cfg && (cfg.skipAuthRedirect || cfg.headers?.['X-Skip-Auth-Redirect']));
      const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
      if (refreshToken && !cfg.__didTryRefresh && !skipAuthRedirect) {
        cfg.__didTryRefresh = true;
        try {
          if (!refreshTokenPromise) {
            refreshTokenPromise = axios({
              method: 'post',
              baseURL,
              url: '/member/auth/refresh-token',
              params: { refreshToken },
              headers: { 'Content-Type': 'application/json;charset=UTF-8' },
              timeout: 15000,
            })
              .then((r) => {
                const p = r.data;
                if (p && (p.code === 0 || p.code === 200) && p.data) {
                  const { accessToken, refreshToken: newRt } = p.data;
                  if (accessToken) localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
                  if (newRt) localStorage.setItem(REFRESH_TOKEN_KEY, newRt);
                  return accessToken;
                }
                throw new Error('REFRESH_FAILED');
              })
              .finally(() => {
                refreshTokenPromise = null;
              });
          }
          const accessToken = await refreshTokenPromise;
          if (accessToken) {
            cfg.headers = cfg.headers || {};
            cfg.headers.Authorization = 'Bearer ' + accessToken;
            return service(cfg);
          }
        } catch (e) {
          /* 刷新失败则走下方登出 */
        }
      }
      try {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
      } catch (e) {}
      // 公开页/可选登录接口：清 token 即可，勿强制跳登录
      if (skipAuthRedirect) {
        return Promise.reject(new Error('UNAUTHORIZED'));
      }
      Message.error(payload.msg || '账号未登录或会话已过期');
      redirectToLogin();
      return Promise.reject(new Error('UNAUTHORIZED'));
    }
    if (!ok) {
      const cfg = response.config || {};
      // 探测类请求（如全局 resume 匹配进度）由调用方自行处理，勿弹全局错误
      if (!(cfg.skipErrorMessage || cfg.headers?.['X-Skip-Error-Message'])) {
        Message.error((payload && payload.msg) || '操作失败');
      }
      return Promise.reject(new Error((payload && payload.msg) || 'BUSINESS_ERROR'));
    }
    return payload;
  },
  (error) => {
    if (showLoading) showLoading.close()
    // 处理 502 Bad Gateway 等服务器错误
    if (error.response) {
      const status = error.response.status
      if (status === 502) {
        Message.error('服务器网关错误，请稍后重试或联系管理员')
      } else if (status === 503) {
        Message.error('服务暂时不可用，请稍后重试')
      } else if (status === 504) {
        Message.error('网关超时，请稍后重试')
      } else if (status >= 500) {
        Message.error('服务器错误，请稍后重试')
      } else if (status === 404) {
        Message.error('请求的资源不存在')
      } else if (status === 403) {
        Message.error('没有权限访问该资源')
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      Message.error('网络错误，请检查网络连接')
    } else {
      // 其他错误
      Message.error(error.message || '请求失败，请稍后重试')
    }
    return Promise.reject(error)
  },
)

export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = rspObj.msg || '下载失败'
      Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}

// 验证是否为blob格式
function blobValidate(data) {
  return data.type !== 'application/json'
}

/**
 * 参数处理
 * @param {*} params  参数
 */
function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

export default service
